<div style="margin-left: 0px;" class="content-wrapper" id="content-wrapper">
  <section class="content-header">
    <h1>
      Desligamento
    </h1>
    <ol class="breadcrumb">
      <li><i class="fa fa-dashboard"></i>&nbsp;&nbsp;&nbsp;Home</li>
      <li>Solicitação</li>
      <li class="active">Desligamento</li>
    </ol>
  </section>

  <!-- modalp popup ends -->
  <section class="content">

    <form id="formulario">
      <div style="margin-left: 0px;">
        <div class="box box-info">
          <div class="box-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Nome do Colaborador</label>
                  <!-- BUSCAR OS DADOS DA TABELA Empresa  -->
                  <select-component (changeValue)="changeSelectValues($event)" [Data]="colaboradorList"
                    IdSelect="selectColaborador" [Value]="colaboradorSelected">
                  </select-component>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-left: 0px;">
        <div class="box box-primary">
          <div class="box-body">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>Data Sugerida</label>
                  <div class="input-group date">
                    <input type="text" mask="00/00/0000" autocomplete="off" class="form-control pull-right" id="txtDataSugerida" name="txtDataSugerida"
                      placeholder="dd/mm/yyyy">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Tipo</label>
                  <!-- BUSCAR OS DADOS DA TABELA DESLIGAMENTO TIPO -->
                  <select-component (changeValue)="changeSelectValues($event)" [Data]="tipoList"
                  IdSelect="selTipo" [Value]="tipoSelected">
                </select-component>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Motivo</label>
                  <!-- BUSCAR OS DADOS DA TABELA DESLIGAMENTO MOTIVO -->
                  <select-component (changeValue)="changeSelectValues($event)" [Data]="motivoList"
                  IdSelect="selMotivo" [Value]="motivoSelected">
                </select-component>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Substituir?</label>
                  <div class="row">
                    <div class="col-md-4" style="text-align: left;">
                      <input type="radio" style="margin-right: 10px;" name="optionsSubstituir" id="substituirRadioSim" value="Sim" checked>Sim
                    </div>
                    <div class="col-md-4" style="text-align: left;">
                      <input type="radio" style="margin-right: 10px;" name="optionsSubstituir" id="substituirRadioNão" value="Não">Não
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Recontrataria?</label>
                  <div class="row">
                    <div class="col-md-4" style="text-align: left;">
                      <input type="radio" style="margin-right: 10px;" name="optionsRecontrataria" id="recontratariaRadioSim" value="Sim" checked>Sim
                    </div>
                    <div class="col-md-4" style="text-align: left;">
                      <input type="radio" style="margin-right: 10px;" name="optionsRecontrataria" id="recontratariaRadioNao" value="Não">Não
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="box-footer">
            <table border=0 width="100%">
              <tr width="100%">
                <td align="left"><button type="reset" (click)="clearInputvalues()"
                    class="btn btn-default">Limpar</button>
                </td>
                <td align="center"><span id="spanErro" name="spanErro" class="error" style="font-weight: bold;"></span>
                </td>
                <td align="right">
                  <input value="Solicitar" readonly="readonly" (click)="solicitar()"
                    class="btn btn-info pull-right btn-margin" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="box box-body">
        <div style="overflow-y: auto;">
          <div style="width: 99%; padding-left: 15px;">
            <table #grid style="width: 100% !important; text-align: center;" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Nome do Colaborador</th>
                  <th>Data Sugerida</th>
                  <th>Tipo</th>
                  <th>Motivo</th>
                  <th>Substituir?</th>
                  <th>Recontrataria?</th>
                  <th>Status</th>
                  <th>Data da Solicitação</th>
                  <th>Data da Conclusão</th>
                  <th>Data do Desligamento</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </form>
  </section>

  <div class="control-sidebar-bg"></div>
</div>
